import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Caption = styled.p`
  ${Typography.Caps}
  ${FontWeights.DemiBold}

  color: ${Colors.Neutral50};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Header = styled.h2`
  ${Typography.M}
  ${FontWeights.Medium}

  color: ${Colors.Neutral90};
`

export const Description = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`
